module.exports = __webpack_public_path__ + "static/shipping-4c4d4f5b3b7e9f52966831188628e6e7.png";